import { AppConfigModel } from '@/models/app/app-config';
import { appConfigSerializer } from '@/providers/serializers/app/app-config';
import { CAP_LIBRARY_USER_IDS } from '@/utils/constants';
import { demoUser } from '@/providers/apis/demo-user/demo-user';

export class AppConfigService {

  static get instance() {
    return this.INSTANCE;
  }

  private static INSTANCE = new AppConfigService();

  public APP_CONFIG: string = 'LI_APP_CONFIG';

  public APP_TRANSCRIPT: string = 'LI_APP_TRANSCRIPT';

  public APP_USER_ROLE: string = 'LI_APP_USER_ROLE';

  public async setAppConfig(appConfigModel: AppConfigModel) {
    localStorage.setItem(this.APP_CONFIG, JSON.stringify(appConfigModel));
  }

  public async setTranscriptConfig(transcript: any) {
    localStorage.setItem(this.APP_TRANSCRIPT, JSON.stringify(transcript));
  }

  public guestAccountDetails() {
    const appConfig = this.getAppConfig();
    return (appConfig && appConfig.guest_account) ? appConfig.guest_account : this.getGuestUser();
  }

  public getGuestUser() {
    return demoUser.getGuestUser().then((data: any) => {
      return data;
    });
  }

  public getLoginPageInfo() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.loginPageInfo ? appConfig.loginPageInfo : null;
  }

  public setAppUserRole(userRole: any) {
    localStorage.setItem(this.APP_USER_ROLE, JSON.stringify(userRole));
  }

  public getApiUrl() {
    const appConfig = this.getAppConfig();
    return appConfig ? appConfig.api_endpoint_url : process.env.VUE_APP_API_URL;
  }

  public getTenantUrl() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.tenantUrl ? appConfig.tenantUrl : null;
  }

  public getAdminUiAppId() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.adminUiAppId ? appConfig.adminUiAppId : null;
  }

  public getNavigatorBasePath() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.S3_BUCKET_ASSETS_BASE_PATH ? appConfig.S3_BUCKET_ASSETS_BASE_PATH : null;
  }

  public getStaticImageUrl() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.STATIC_IMAGE_URL ? appConfig.STATIC_IMAGE_URL : null;
  }

  public getEnvironmentCopy() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.environmentCopy ? appConfig.environmentCopy : 'stage';
  }

  public getGuestAccount() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.guestAccount ? appConfig.guestAccount : null;
  }

  public getAppUserRole() {
    let role = null;
    const userRole = localStorage.getItem(this.APP_USER_ROLE);
    if ( userRole ) {
      role = JSON.parse(userRole);
    }
    return role;
  }
  public getClientId() {
    return process.env.VUE_APP_CLIENT_ID;
  }

  public getClientKey() {
    return process.env.VUE_APP_CLIENT_KEY;
  }

  public getShareableAdminUserDetail() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.shareableAccount;
  }

  public libraryPageUsers() {
    const appConfig = this.getAppConfig();
    return (appConfig && appConfig!.capAccessIds) ? appConfig!.capAccessIds : CAP_LIBRARY_USER_IDS;
  }

  public includeCapLibrayList() {
    const appConfig = this.getAppConfig();
    return (appConfig && appConfig!.includeCap) ? appConfig!.includeCap : {};
  }

  public getAppConfig() {
    let appConfig = null;
    const appConfigAsString: string | null = localStorage.getItem(this.APP_CONFIG);
    if (appConfigAsString) {
      const appConfigAsJson = JSON.parse(appConfigAsString);
      appConfig = appConfigSerializer.appConfigModelSerializer(appConfigAsJson);
    }
    return appConfig;
  }

  public getTranscriptConfig() {
    let transcriptConfig = null;
    const transcriptConfigAsString: string | null = localStorage.getItem(this.APP_TRANSCRIPT);
    if (transcriptConfigAsString) {
      const transcriptConfigAsJson = JSON.parse(transcriptConfigAsString);
      transcriptConfig = transcriptConfigAsJson;
    }
    return transcriptConfig;
  }


  public getBearerToken() {
    const appConfig = this.getAppConfig();
    return appConfig && appConfig.bearerToken ? appConfig.bearerToken : null;
  }
}

export const appConfigService = AppConfigService.instance;
